import { DASH_META_ROOT, getAuthDashMetaCsrfToken } from '@revelio/auth';

import {
  parseRetryAfterSeconds,
  SharedReportRateLimitError,
} from './dash-meta-rate-limit-error';

interface CreateSharedReportPayload {
  name: string;
  pageConfig: Record<string, unknown>;
  chartData: Record<string, unknown>;
  pageState: Record<string, unknown>;
}

interface CreateSharedReportResponse {
  token: string;
}

export interface SharedReportSnapshot {
  token: string;
  name: string;
  pageConfig: Record<string, unknown>;
  chartData: Record<string, unknown>;
  pageState: Record<string, unknown>;
  created: string;
}

export const createSharedReport = async (
  payload: CreateSharedReportPayload
): Promise<CreateSharedReportResponse> => {
  const csrfToken = getAuthDashMetaCsrfToken();

  const response = await fetch(`${DASH_META_ROOT}/api/shared-reports`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-surf-token-dash-meta': csrfToken ?? '',
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 429) {
    throw new SharedReportRateLimitError(parseRetryAfterSeconds(response));
  }

  if (!response.ok) {
    throw new Error('Failed to create shared report');
  }

  return response.json();
};

export const getSharedReport = async (
  token: string
): Promise<SharedReportSnapshot> => {
  const response = await fetch(`${DASH_META_ROOT}/api/shared-reports/${token}`);

  if (!response.ok) {
    throw new Error('Shared report not found');
  }

  return response.json();
};
